module.exports = __webpack_public_path__ + "static/media/logo.73264041.svg";